import React from 'react';

const ClearChatModal = ({ isOpen, onConfirm, onCancel, chatName }) => {
    if (!isOpen) return null;

    const overlayStyle = {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 100000,
        backdropFilter: 'blur(4px)'
    };

    return (
        <div className="clear-chat-modal-overlay" style={overlayStyle}>
            <div className="admin-modal-content">
                <h3 className="modal-title">Clear Conversation?</h3>
                <p className="modal-subtitle">
                    Are you sure you want to clear all messages with <strong>{chatName}</strong>?
                    This action cannot be undone.
                </p>
                <div className="admin-modal-actions">
                    <button className="btn-cancel" onClick={onCancel}>
                        Keep Messages
                    </button>
                    <button className="btn-confirm danger" onClick={onConfirm}>
                        Clear Chat
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ClearChatModal;